// queries/useGetUserTransactions.ts
"use client";
import { GET_USER_TRANSACTIONS } from "api";
import { fetch } from "libs";
import { useQuery } from "@tanstack/react-query";

const fetchUserTransactions = async (pageParam: number = 1, pageSize: number = 16) => {
  return fetch(`${GET_USER_TRANSACTIONS}?page=${pageParam}&page_size=${pageSize}`);
};

export const useGetUserTransactions = ({
  pageSize = 4,
  page = 1,
}: {
  pageSize: number;
  page: number;
}) => {
  // @ts-ignore
  return useQuery({
    queryKey: ["userTransactions", page],
    queryFn: () => fetchUserTransactions(page, pageSize),
    enabled: page > 0,
  });
};

export default useGetUserTransactions;
